import { cn } from "../../utils";
import { EmptyState } from "../EmptyState";
import type { EmptyStateProps } from "../EmptyState/types";
import { useTableContext } from "./context";

export const TableEmptyState = () => {
  const { emptyState } = useTableContext();

  const emptyStateProps: EmptyStateProps = {
    size: "sm",
    ...emptyState,
  };

  return (
    <EmptyState
      {...emptyStateProps}
      className={cn("sticky start-0 py-10", emptyStateProps.className)}
    />
  );
};
